/* eslint-disable prettier/prettier */
import React from 'react';
import styles from './ActivityItem.module.css';

export interface ActivityItemProps {
	// Left section
	leftIcon?: string;
	leftIconBg?: string;

	title: string;
	subtitle?: string;

	// Right section (can be icon OR text)
	rightIcon?: string;
	rightText?: string;

	// Actions
	onClick?: () => void;
	onRightClick?: () => void;

	// Style overrides
	containerBg?: string;
	hoverBg?: string;
}

const ActivityItem: React.FC<ActivityItemProps> = ({
	leftIcon,
	leftIconBg = '#E6F4F1',
	title,
	subtitle,

	rightIcon,
	rightText,

	onClick,
	onRightClick,

	containerBg = '#fff',
	hoverBg = '#f5f5f5',
}) => {
	return (
		<div
			className={styles.container}
			style={{ background: containerBg }}
			onClick={onClick}
		>
			{/* LEFT */}
			<div className={styles.left}>
				{leftIcon && (
					<div
						className={styles.iconWrapper}
						style={{ background: leftIconBg }}
					>
						<img src={leftIcon} className={styles.icon} />
					</div>
				)}

				<div className={styles.textContainer}>
					<span className={styles.title}>{title}</span>
					{subtitle && (
						<span className={styles.subtitle}>{subtitle}</span>
					)}
				</div>
			</div>

			{/* RIGHT */}
			<div className={styles.right}>
				{rightIcon && (
					<button
						className={styles.iconButton}
						onClick={e => {
							e.stopPropagation();
							onRightClick?.();
						}}
					>
						<img src={rightIcon} className={styles.icon2} />
					</button>
				)}

				{rightText && (
					<span className={styles.rightText}>{rightText}</span>
				)}
			</div>
		</div>
	);
};

export default ActivityItem;
